/*
 * Opening the mobile navbar
 */

function toggleMobileSidebar() {
  const sidebar = document.querySelector('.mobile-sidebar');
  const menuButton = document.querySelector('.menu-btn');
  const body = document.querySelector('body');

  if (sidebar) {
    sidebar.classList.toggle('hidden');
    menuButton.classList.toggle('menu-btn--active');
    body.classList.toggle('overflow-hidden');
  }
}

function toggleMenu(e) {
  const menuItem = e.currentTarget.parentElement;
  const menuIcon = e.currentTarget.querySelector('i');

  menuItem.classList.toggle('nav-item--open');
  menuIcon.classList.toggle('fa-chevron-down');
  menuIcon.classList.toggle('fa-chevron-up');
}

function attemptAttachingListener(selector) {
  const el = document.querySelector(selector);
  if (el) {
    el.addEventListener('click', toggleMobileSidebar);
  }
}

function attachListenersToMenuItems() {
  const menu = document.querySelector('.mobile-sidebar');
  if (!menu) return;
  const menuItems = menu.querySelectorAll('.nav-item>span');
  if (!menuItems) return;

  menuItems.forEach((i) => i.addEventListener('click', toggleMenu));
}

attemptAttachingListener('#toggle-mobile-navbar');
attemptAttachingListener('.mobile-sidebar .backdrop');
attemptAttachingListener('.mobile-sidebar .fa-times');
attachListenersToMenuItems();
